import Secteur from "@/pages/administrer/configuration/secteurs/Secteur.vue";
import ShowSecteur from "@/pages/administrer/configuration/secteurs/ShowSecteur.vue";
import CreateSecteur from "@/pages/administrer/configuration/secteurs/CreateSecteur.vue";

export default [{
    path: 'secteurs',
    meta: { permissions: ["view_secteur"] },
    name: "AdminConfigSecteur",
    component: Secteur
},
{
    path: 'secteurs/create',
    meta: { permissions: ["create_secteur"] },
    name: "AdminConfigCreateSecteur",
    component: CreateSecteur
},
{
    path: 'secteurs/:id/show',
    meta: { permissions: ["view_any_secteur"] },
    name: "AdminConfigShowSecteur",
    component: ShowSecteur
},]